import React from "react";
import "./nav.css";
import warpLogo from "../../assets/400px-x-140px.png";

const Nav = () => {
  return (
    <div>
      <header className="fixed top-0 z-50 w-full border-b border-brand-border bg-white/40 backdrop-blur-md">
        <div className="mx-auto flex md:h-24 max-w-7xl items-center justify-between px-4 md:px-6 lg:px-8">
          <a
            className="flex items-center rounded-2xl  px-2 py-2 transition-colors "
            href="https://warpspeedmortgage.com"
          >
            <img
              className="header-logo w-auto max-w-[180px] md:max-w-[220px] object-contain"
              src={warpLogo}
              alt="Warp Speed Mortgage"
            />
          </a>
        </div>
      </header>
    </div>
  );
};

export default Nav;
